import numbersHelper from "./numbers.helpers";

const mapProductToCartItem = (product, quantity = 1) => {
  return {
    id: product.id,
    name: product.productName,
    price: product.price || 0, // Fallback price logic
    salePrice: product.salePrice || 0,
    quantity, // Set the passed quantity instead of always defaulting to 1
    image: product.image
      ? product.image
      : product.images?.find((img) => img.id === product.primaryImageId)?.url || product.images[0]?.url, // Get primary image URL
    attributes:
      product.attributes?.map((attr) => ({
        name: attr.name,
        value: attr.attributeValues.map((val) => val.value).join(", "), // Join attribute values
      })) || [],
  };
};

// Calculate Total Price (without VAT)
const calculateTotalPrice = (cartItemList) => {
  const totalCalculatedPrice = cartItemList.reduce((total, item) => {
    return total + item.quantity * item.price;
  }, 0);
  return numbersHelper.formatToTwoDecimalPlaces(totalCalculatedPrice);
};

// Calculate VAT Price
const calculateVatPrice = (totalPrice, vatPercent) => {
  return numbersHelper.formatToTwoDecimalPlaces((totalPrice * vatPercent) / 100);
};

// Calculate Total Price with VAT
const calculateTotalPriceWithoutVat = (cartItemList, vatPercent) => {
  const totalPrice = calculateTotalPrice(cartItemList);
  const vatPrice = calculateVatPrice(totalPrice, vatPercent);
  return numbersHelper.formatToTwoDecimalPlaces(+totalPrice - +vatPrice);
};

const shoppingCartHelper = {
  mapProductToCartItem,
  calculateTotalPrice,
  calculateVatPrice,
  calculateTotalPriceWithoutVat,
};
export default shoppingCartHelper;
